import { render } from "./Homepage24hTelevie.vue?vue&type=template&id=6c4d87b8&scoped=true"
import script from "./Homepage24hTelevie.vue?vue&type=script&lang=js"
export * from "./Homepage24hTelevie.vue?vue&type=script&lang=js"

import "./Homepage24hTelevie.vue?vue&type=style&index=0&id=6c4d87b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4d87b8"]])

export default __exports__